export default __webpack_public_path__ + "static/media/thumb_gear-lounge.13499a2d.jpg";